import maestroApiRequest from 'services/maestro-api-client';
import { DropdownOption, GameType } from '../../utils';
import { EPICGAMES_SERVICE_BASE_URL } from 'config';

type BaseParams = {
  primaryToken: string;
  siteId: string;
};

type GetTournamentsParams = {
  gameType: GameType;
  season: string;
} & BaseParams;

export const getTournaments = async ({
  gameType,
  primaryToken,
  season,
  siteId,
}: GetTournamentsParams): Promise<DropdownOption[]> => {
  const response = await maestroApiRequest({
    primaryToken,
    siteId,
  }).get<DropdownOption[]>(`${EPICGAMES_SERVICE_BASE_URL}/fortnite/leaderboard/tournaments`, {
    params: {
      season,
      gameType,
    },
  });

  return response.data;
};

type GetSeasonsParams = {
  gameType: GameType;
} & BaseParams;

export const getSeasons = async ({
  gameType,
  primaryToken,
  siteId,
}: GetSeasonsParams): Promise<DropdownOption[]> => {
  const response = await maestroApiRequest({
    primaryToken,
    siteId,
  }).get<DropdownOption[]>(`${EPICGAMES_SERVICE_BASE_URL}/fortnite/leaderboard/seasons`, {
    params: {
      gameType,
    },
  });

  return response.data;
};

type GetSessionsParams = {
  eventId: string;
} & BaseParams;

export const getSessions = async ({
  eventId,
  primaryToken,
  siteId,
}: GetSessionsParams): Promise<DropdownOption[]> => {
  const response = await maestroApiRequest({
    primaryToken,
    siteId,
  }).get<DropdownOption[]>(`${EPICGAMES_SERVICE_BASE_URL}/fortnite/leaderboard/sessions`, {
    params: {
      eventId,
    },
  });

  return response.data;
};
